import {Component, Vue} from 'nuxt-property-decorator'
import {Accrual} from '@pp-frontend/shared-packages/types/accrual/Accrual'

export interface AllAccrual extends Accrual {
  licence_plate?: string
}

/**
 * Класс для работы со списком начислений
 */
@Component
export default class extends Vue {
  // Список всех начислений
  private accruals: Accrual[] = []

  // Список выбранных к оплате начислений
  private markToPayAccrualList: Accrual[] = []

  /**
   * Добавляет новые начисления к уже существующим
   * Присутствует проверка уникальности УИН
   *
   * @param {Accrual[]} accruals - список задолженностей, которые нужно добавить
   * @param {string} licence_plate - госсномер для всех штрафов
   */
  public addAccruals (accruals?: Accrual[], licence_plate?: string): void {
    if (!accruals) {
      return
    }

    /** проверка уникальности начислений */
    accruals.forEach((newItem: AllAccrual) => {
      if (this.accruals.find(item => newItem.uin === item.uin) === undefined) {
        newItem.licence_plate = licence_plate
        this.accruals.push(newItem)
      }
    })
    /** добавление начислений до 500k */
    this.selectAllBefore500()
  }

  public setAccruals (accruals?: Accrual[]): void {
    this.accruals = []
    this.markToPayAccrualList = []
    if (accruals) {
      accruals.forEach((newItem: Accrual) => {
        if (!this.accruals.some((accrual: Accrual) => {
          return accrual.uin === newItem.uin
        })) {
          this.accruals.push(newItem)
          if (newItem.status.id === 'payed') return
          this.markToPayAccrualList.push(newItem)
        }
      })
    }
  }

  public getAccruals (): Accrual[] {
    return this.accruals
  }

  public clearAccruals () {
    this.accruals = []
    this.markToPayAccrualList = []
  }

  public getMarkToPayAccrualList (): Accrual[] {
    return this.markToPayAccrualList
  }

  public selectAllBefore500 () {
    if (this.accruals.length === 1) {
      this.toggleAccrual(this.accruals[0])
      return
    }

    let totalSum = 0
    this.accruals.slice().forEach((accrual) => {
      // @todo ??? комиссия мб разной
      if (totalSum + accrual.left_sum < 475_000) {
        totalSum += accrual.left_sum
        this.toggleAccrual(accrual)
      }
    })
  }

  setAccuralPaymentAmount(uin: string, payment_amount: number | string) {
    const accrual = this.accruals.find(accrual => accrual.uin === uin)
    if (accrual && +payment_amount) {
      accrual.sum = +payment_amount
      accrual.total_sum = +payment_amount
    } else {
      throw new Error('uin не найден в списке')
    }
  }

  /**
   * Возвращаем список выбранных начислений в нужном формате для
   * перехода на страницу оплаты
   */
  public getMarkToPayAccruals ():{ uin:string, payment_amount:number }[] {
    return this.markToPayAccrualList.map((item: Accrual) => {
      return {
        uin: item.uin,
        payment_amount: item.sum
      }
    })
  }

  /**
   * Общая сумма всех начислений выбранных к оплате
   *
   * @returns {number} sum
   */
  public paymentAmount (): number {
    let sum = 0
    this.markToPayAccrualList.forEach((fine) => {
      sum += fine.sum
    })
    return sum
  }

  /**
   * Общее количество начислений выбранных к оплате
   *
   * @returns {number} count
   */
  public paymentCount (): number {
    return this.markToPayAccrualList.length
  }

  /**
   * Полная сумма к оплате
   *
   * @returns {number} sum
   */
  public paymentTotal (): number {
    let sum = 0

    this.markToPayAccrualList.forEach((accrual) => {
      sum += accrual.total_sum
    })
    return sum
  }

  /**
   * Сумма к оплате с учетом скидок
   *
   * @returns {number} total
   */
  public paymentDiscountTotal (): number {
    let total = 0

    this.markToPayAccrualList.forEach((accrual) => {
      total += accrual.total_sum - accrual.sum
    })
    return total
  }

  /**
   * Запрещаем частичную оплату, если один из штрафов меньше нуля
   *
   * @returns {boolean} true/false
   */
  public formDisabled (): boolean {
    return this.markToPayAccrualList.some((fine) => {
      return fine.sum < 0.01
    })
  }

  /**
   * Добавляем/убираем начисление из списка оплаты
   *
   * @param {Accrual} accrual - переключаемое начисление
   */
  public toggleAccrual(accrual: Accrual): void {
    if (accrual.status.id === 'payed') return

    if (!this.isAccrualInPayList(accrual)) {
      this.markToPayAccrualList.push(accrual)
    } else {
      this.markToPayAccrualList.splice(this.markToPayAccrualList.indexOf(accrual), 1)
    }
  }

  /**
   * Проверяем наличие начисления в списке выбранных к оплате
   *
   * @param {Accrual} accrual - проверяемое начисление
   * @returns {boolean} true/false
   */
  public isAccrualInPayList (accrual: Accrual): boolean {
    return this.markToPayAccrualList.includes(accrual)
  }
}
